import { render, staticRenderFns } from "./limitImport.vue?vue&type=template&id=6fcba413&scoped=true&"
import script from "./limitImport.vue?vue&type=script&lang=js&"
export * from "./limitImport.vue?vue&type=script&lang=js&"
import style0 from "./limitImport.vue?vue&type=style&index=0&id=6fcba413&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcba413",
  null
  
)

export default component.exports